export enum VideoPlugins {
    AUTOPLAY = 'Autoplay',
    STICKY = 'Sticky',
    ANALYTICS = 'Analytics',
    DEBUG = 'Debug'
}
